module.exports = __webpack_public_path__ + "img/envelope.43274d32.svg";